import { Matrix } from "@babylonjs/core/Maths/math.vector";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { PolygonMeshBuilder } from "@babylonjs/core/Meshes/polygonMesh";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import * as MyEarcut from "earcut";
import { CsgUtils } from "../CsgUtils";
import { Util } from "../../utils/Util";
import { degToRad, PI_DIV2 } from '@egr/wcf/modules/utils/math';
export class GeoUtils {
    static createFrame(pWidth, pHeight, pDepth, pThickness, pParent, pScene) {
        let tOuter = [
            new Vector2(pWidth, pHeight),
            new Vector2(0.0, pHeight),
            new Vector2(0.0, 0.0),
            new Vector2(pWidth, 0.0)
        ];
        let tInner = [
            new Vector2(pWidth - pThickness, pHeight - pThickness),
            new Vector2(pThickness, pHeight - pThickness),
            new Vector2(pThickness, pThickness),
            new Vector2(pWidth - pThickness, pThickness)
        ];
        let tBuilder = new PolygonMeshBuilder("", tOuter, pScene, MyEarcut);
        tBuilder.addHole(tInner);
        let tFrame = tBuilder.build(false, pDepth);
        if (tFrame != null) {
            let tM = Matrix.Translation(-pWidth * 0.5, pDepth * 0.5, -pHeight * 0.5);
            tM.multiplyToRef(Matrix.RotationX(-PI_DIV2), tM);
            tFrame.bakeTransformIntoVertices(tM);
            tFrame.parent = pParent;
        }
        return (tFrame);
    }
    static createFrame_CAG(pWidth, pHeight, pDepth, pThickness, pParent, pLeft = true, pScene) {
        let tWH = pWidth * 0.5;
        let tDH = pDepth * 0.5;
        let tHH = pHeight * 0.5;
        let tPoints = new Array();
        tPoints.push(new CSG.Vector2D(pWidth, pHeight));
        tPoints.push(new CSG.Vector2D(0.0, pHeight));
        tPoints.push(new CSG.Vector2D(0.0, 0.0));
        tPoints.push(new CSG.Vector2D(pThickness, 0.0));
        tPoints.push(new CSG.Vector2D(pThickness, pHeight - pThickness));
        tPoints.push(new CSG.Vector2D(pWidth - pThickness, pHeight - pThickness));
        tPoints.push(new CSG.Vector2D(pWidth - pThickness, 0.0));
        tPoints.push(new CSG.Vector2D(pWidth, 0.0));
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (tCAGshape.isSelfIntersecting())
            return (null);
        let tCSG = Util.CAG2CSG(tCAGshape, pDepth);
        let tMeshes = CsgUtils.buildMeshes(tCSG, pScene);
        if (tMeshes == null)
            return (null);
        // bottom part
        let tPoints1 = new Array();
        tPoints1.push(new CSG.Vector2D(pWidth - pThickness, pThickness));
        tPoints1.push(new CSG.Vector2D(pThickness, pThickness));
        tPoints1.push(new CSG.Vector2D(pThickness, 0.0));
        tPoints1.push(new CSG.Vector2D(pWidth - pThickness, 0.0));
        let tCAGshape1 = CAG.fromPointsNoCheck(tPoints1);
        if (tCAGshape1.isSelfIntersecting())
            return (null);
        let tCSG1 = Util.CAG2CSG(tCAGshape1, pDepth);
        let tMeshes1 = CsgUtils.buildMeshes(tCSG1, pScene);
        if (tMeshes1 == null)
            return (null);
        let tFrame1 = Mesh.MergeMeshes(tMeshes1);
        let tFrame0 = Mesh.MergeMeshes(tMeshes);
        if (tFrame1 == null || tFrame0 == null)
            return (null);
        let tFrame = Mesh.MergeMeshes([tFrame0, tFrame1]);
        if (tFrame == null)
            return (null);
        tFrame.position.x -= tWH;
        tFrame.position.z = tDH;
        tFrame.position.y = -tHH;
        tFrame.rotation.x = degToRad(-90);
        if (!pLeft) {
            tFrame.scaling.x *= -1;
            tFrame.position.x = tWH;
        }
        tFrame.bakeCurrentTransformIntoVertices();
        tFrame.parent = pParent;
        return (tFrame);
    }
    static createOpenFrame(pWidth, pHeight, pDepth, pThickness, pParent, pScene) {
        let tOuter = [
            new Vector2(pWidth, pHeight),
            new Vector2(0.0, pHeight),
            new Vector2(0.0, 0.0),
            new Vector2(pThickness, 0.0),
            new Vector2(pThickness, pHeight - pThickness),
            new Vector2(pWidth - pThickness, pHeight - pThickness),
            new Vector2(pWidth - pThickness, 0.0),
            new Vector2(pWidth, 0.0)
        ];
        let tBuilder = new PolygonMeshBuilder("", tOuter, pScene, MyEarcut);
        let tFrame = tBuilder.build(false, pDepth);
        if (tFrame != null) {
            let tM = Matrix.Translation(-pWidth * 0.5, pDepth * 0.5, -pHeight * 0.5);
            tM.multiplyToRef(Matrix.RotationX(-PI_DIV2), tM);
            tFrame.bakeTransformIntoVertices(tM);
            tFrame.parent = pParent;
        }
        return (tFrame);
    }
    static createOpenFrame_CAG(pWidth, pHeight, pDepth, pThickness, pParent, pScene) {
        let tWH = pWidth * 0.5;
        let tDH = pDepth * 0.5;
        let tHH = pHeight * 0.5;
        let tPoints = new Array();
        tPoints.push(new CSG.Vector2D(pWidth, pHeight));
        tPoints.push(new CSG.Vector2D(0.0, pHeight));
        tPoints.push(new CSG.Vector2D(0.0, 0.0));
        tPoints.push(new CSG.Vector2D(pThickness, 0.0));
        tPoints.push(new CSG.Vector2D(pThickness, pHeight - pThickness));
        tPoints.push(new CSG.Vector2D(pWidth - pThickness, pHeight - pThickness));
        tPoints.push(new CSG.Vector2D(pWidth - pThickness, 0.0));
        tPoints.push(new CSG.Vector2D(pWidth, 0.0));
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (tCAGshape.isSelfIntersecting())
            return (null);
        let tCSG = Util.CAG2CSG(tCAGshape, pDepth);
        let tMeshes = CsgUtils.buildMeshes(tCSG, pScene);
        if (tMeshes == null)
            return (null);
        let tFrame = Mesh.MergeMeshes(tMeshes);
        if (tFrame == null)
            return (null);
        tFrame.parent = pParent;
        tFrame.position.x -= tWH;
        tFrame.position.z = tDH;
        tFrame.rotation.x = degToRad(-90);
        return (tFrame);
    }
    static createBoxWithHole_CAG(pWidth, pDepth, pThickness, pParent, pScene) {
        const tW = pWidth;
        const tWH = pWidth * 0.5;
        const tD = pDepth;
        const tDH = pDepth * 0.5;
        const tT = pThickness;
        const tTH = tT * 0.5;
        let tBox = CSG.cube({ radius: [tWH, tTH, tDH], center: [0, 0, 0] });
        tBox = tBox.rotateX(90);
        tBox = tBox.translate([0, tWH, 0]);
        let tHole = CSG.cylinder({
            start: [0, 0, -tTH], end: [0, 0, tTH], radius: tWH,
            resolution: 50
        });
        tHole = tHole.translate([0, tWH, 0]);
        let tBoxWithHoleCSG = tBox.subtract(tHole);
        tBoxWithHoleCSG = tBoxWithHoleCSG.translate([0, -tWH, 0]);
        const tMeshes = CsgUtils.buildMeshes(tBoxWithHoleCSG, pScene);
        if (tMeshes == null)
            return (null);
        const tBoxWithHole = Mesh.MergeMeshes(tMeshes);
        if (tBoxWithHole == null)
            return (null);
        tBoxWithHole.parent = pParent;
        return (tBoxWithHole);
    }
    static createTriangle(pLength, pArrowDepth, pParent, pScene) {
        const tW = pLength * 0.5;
        const tD = pArrowDepth * 0.5;
        let tPoints = new Array();
        tPoints.push(new CSG.Vector2D(-0.05, 0));
        tPoints.push(new CSG.Vector2D(0.05, -0.0375));
        tPoints.push(new CSG.Vector2D(0.05, 0.0375));
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (tCAGshape.isSelfIntersecting())
            return (null);
        let tCSG = Util.CAG2CSG(tCAGshape, 0);
        let tMeshes = CsgUtils.buildMeshes(tCSG, pScene);
        if (tMeshes == null)
            return (null);
        let tRes = Mesh.MergeMeshes(tMeshes);
        if (tRes == null)
            return (null);
        tRes.parent = pParent;
        return (tRes);
    }
}
